import { gql } from '@apollo/client';

export default gql`
  mutation adjustPoints(
    $membershipNumber: String!
    $amount: Float!
    $reasonCode: String!
    $reasonText: String!
    $useNewLoyaltySystem: Boolean
  ) {
    adjustPoints(
      membershipNumber: $membershipNumber
      amount: $amount
      reasonCode: $reasonCode
      reasonText: $reasonText
      useNewLoyaltySystem: $useNewLoyaltySystem
    ) {
      success
    }
  }
`;
